import { render } from "./HistoryListView.vue?vue&type=template&id=248586ef&scoped=true"
import script from "./HistoryListView.vue?vue&type=script&lang=js"
export * from "./HistoryListView.vue?vue&type=script&lang=js"

import "./HistoryListView.vue?vue&type=style&index=0&id=248586ef&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248586ef"]])

export default __exports__